// extracted by mini-css-extract-plugin
export default {"message":"styles_message__olB6p","video":"styles_video__kGDXe"};